import useHomepageStructuredDataQuery from '../../../../../hooks/useHomepageStructuredDataQuery';

const StructuredData = () => {
  const data = useHomepageStructuredDataQuery();

  const homepageStructuredData = data?.wp?.sitewideSettings?.optionsSitewideSettings?.homepageStructuredData;

  if (homepageStructuredData) {
    return (
      <script type="application/ld+json">{homepageStructuredData}</script>
    );
  }

  return null;
};

export default StructuredData;
